<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Budget",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Revenue Projection",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Budget",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "category",
          label: "Expense Category",
          sortable: true,
        },
        {
          sortable: false,
          key: "items_field",
          label: "Expense Items Budget",
        },
      ],
      data: {
        fyear: "",
      },
      project: {
        amount: "",
        item: "",
      },
      assigned: [],
      fyearError: "",
    };
  },
  computed: {
    ...mapGetters("budget", [
      "FinancialYears",
      "ExpenseProjection",
      "SaveStatus",
    ]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.assigned ? this.assigned.length : 1;
    },
  },
  watch: {
    ExpenseProjection(newValue) {
      if (newValue) {
        this.assign();
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.assigned ? this.assigned.length : 1;
  },
  methods: {
    ...mapActions({
      FetchFinancialYear: "budget/fetchFyears",
      FetchExpProjection: "budget/fetchExpProjection",
      AddProjection: "budget/addExpenseProjection",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.assigned ? this.assigned.length : 1;
      this.currentPage = 1;
    },
    edit(values) {
      this.project.item = values;
    },
    addProjection(value) {
      this.project.amount = value;
      this.AddProjection(this.project);
    },
    assign() {
      this.assigned = this.ExpenseProjection;
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchFinancialYear();
    this.FetchExpProjection(this.data);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_expense_projections')
        )
      "
    >
      <div class="col-md-10">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Financial Year</label>
                      <div class="input-group">
                        <model-list-select
                          :list="FinancialYears ? FinancialYears : []"
                          v-model="data.fyear"
                          option-value="id"
                          option-text="name"
                          class="mb-2"
                          @input="resetError()"
                          placeholder="Select Financial Year"
                        >
                        </model-list-select>
                      </div>
                      <div class="text-danger" v-if="fyearError">
                        <em>{{ fyearError }}</em>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-4">
                    <button class="btn btn-success">
                      <i class="fa fa-search"></i> Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="assigned ? assigned : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(items_field)="data">
                  <table width="100%">
                    <tr v-for="(item, index) in data.item.items" :key="index">
                      <td width="50%">{{ item.itemName }}</td>
                      <td width="50%">
                        <input
                          type="text"
                          class="form-control custom"
                          v-model="item.amount"
                          @input="
                            addProjection($event.target.value),
                              edit(item.itemId)
                          "
                        />
                      </td>
                    </tr>
                  </table>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.required {
  color: red !important;
}
/* .custom{
    width: 350px;
} */
</style>
